import { fetchData } from "@client";

export async function getCompanyFontsQuery() {
  const res = await fetchData(`/fonts`);
  return res.results;
}
